// Per-user notification preferences. (kind, channel) → enabled, plus a
// per-user digest setting that buckets non-realtime channels.
import { z } from 'zod';
import { NotificationChannel } from '../primitives/notification-subject.js';
// ---------------------------------------------------------------------------
// Digest cadence
// ---------------------------------------------------------------------------
export const DigestCadence = z.enum(['off', 'daily', 'weekly']);
// ---------------------------------------------------------------------------
// Per (user, kind, channel) preference row.
// ---------------------------------------------------------------------------
export const NotificationPrefRow = z.object({
    userId: z.string().uuid(),
    /** Notification kind (open registry; matches NotificationSubject.kind). */
    kind: z.string().min(1),
    channel: NotificationChannel,
    enabled: z.boolean(),
    /** When set, this row's channel is digested rather than fired live. */
    digest: DigestCadence,
});
// ---------------------------------------------------------------------------
// Per-user quiet-hours window — applied across all channels except `in-app`.
// ---------------------------------------------------------------------------
export const QuietHours = z.object({
    /** "22:00" — local-to-viewer-tz. */
    start: z.string().regex(/^\d{2}:\d{2}$/),
    /** "07:00". */
    end: z.string().regex(/^\d{2}:\d{2}$/),
    /** Defaults to viewer's preferredTz. */
    tzid: z.string().optional(),
});
//# sourceMappingURL=notification-prefs.js.map